module.exports = __webpack_public_path__ + "img/meteorologico_hover.f0ae569d.svg";